import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IInitialState } from './types'
import { postNotificationViewedThunk, getNotificationListThunk } from './asyncthunk'


const initialState: IInitialState = {
    loading: false,
    error: null,
    notificationList: {
        new: [],
        earlier: []
    },
}

const NotificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                postNotificationViewedThunk.fulfilled,
                (state, action) => {
                    const id = action.meta.arg
                    const lists = [state.notificationList.new, state.notificationList.earlier]
                    lists.forEach((list: any[]) =>
                        list.forEach((n: any) => {
                            if (n?.id === id) n.viewed = true
                        }),
                    )
                },
            )
            .addCase(
                getNotificationListThunk.pending,
                (state) => {
                    state.loading = true
                },
            )
            .addCase(
                getNotificationListThunk.fulfilled,
                (state, action: PayloadAction<any>) => {
                    state.notificationList = action.payload
                    state.loading = false
                },
            )
            .addCase(
                getNotificationListThunk.rejected,
                (state) => {
                    state.loading = false
                },
            )


    }
})

export const selectNotification = (state: any) => state.notificationReducer.notificationList
export const selectNotificationLoading = (state: any) => state.notificationReducer.loading


export default NotificationSlice.reducer